import { render } from "./ArvoreInfoComponent.vue?vue&type=template&id=f1795e18&scoped=true"
import script from "./ArvoreInfoComponent.vue?vue&type=script&lang=js"
export * from "./ArvoreInfoComponent.vue?vue&type=script&lang=js"

import "./ArvoreInfoComponent.vue?vue&type=style&index=0&id=f1795e18&scoped=true&lang=css"
import "./ArvoreInfoComponent.vue?vue&type=style&index=1&id=f1795e18&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1795e18"]])

export default __exports__